import {NavBlog, Blackjacklogo} from '../ImageLoader';
import {
  Link
} from "react-router-dom";
import DocumentTitle from '../DocumentTitle';

const Page_Projects = () => {
    DocumentTitle("CW Creations - Dev Consult Share | Products");
    return (<div className='Projects'>
              <table id='tblProjects'>
                <tbody>
                  <tr>
                    <td><img id='cwbjlogoresized' src={Blackjacklogo}/></td>
                    <td><img src={NavBlog}/><a href="https://cwcreations.net/blog/"></a></td>
                  </tr>
                  <tr>
                    <td><a href="https://cwblackjack.cwcreations.net/"><p><b>Play now</b></p></a></td>
                    <td><a href="https://cwcreations.net/blog/"><p><b>Read now</b></p></a></td>
                  </tr>
                  <tr>
                    <td><Link to="/blackjackdemo"><p>Watch Demo</p></Link></td>
                  </tr>
                  <tr>
                    <td><Link to="/manage-cwgames-account"><p>Manage Your Account</p></Link></td>
                  </tr>
                  <tr>
                    <td><p>Aims to provide a realistic blackjack simulation for advantage players and thrill seekers. Enjoyed with friends or solo.</p></td>
                    <td><p>Contains informative threads and opinion by staff and affiliates</p></td>
                  </tr>
                </tbody>
              </table>
            </div>);
}

const Blackjack_Demo = () => {
  return (<div className='blackjackdemo'>
            <iframe class="rumble" width="736" height="414" src="https://rumble.com/embed/v6tv8c4/?pub=oxh8p" frameborder="0" allowfullscreen></iframe>
          </div>);
}

export {Page_Projects,Blackjack_Demo};